import AddressCell, { makeAddressCell } from './address_cell';
import CurrencyCell from './currency_cell';
import DateAndTimeCell from './date_and_time_cell';
import DateTimeCell from './datetime_cell';
import DefaultCell, { makeDefaultCell, makeCountCell } from './default_cell';
import DepartmentCell from './department_cell';
import HeaderCell, { makeHeaderCell } from './header_cell';
import OfferButtonsCell from './offer_buttons_cell';
import PartnerStatusCell from './partner_status_cell';
import PropertyHeaderCell from './property_header_cell';
import PropertyStatusCell from './property_status_cell';
import StatusCell from './status_cell';
import TypeCell from './type_cell';
import PeopleAvatarCell from './people_avatar_cell';
import UsersCell from './users_cell';

export default {
  AddressCell,
  CurrencyCell,
  DateAndTimeCell,
  DateTimeCell,
  DefaultCell,
  DepartmentCell,
  HeaderCell,
  OfferButtonsCell,
  PartnerStatusCell,
  PropertyHeaderCell,
  PropertyStatusCell,
  StatusCell,
  TypeCell,
  PeopleAvatarCell,
  UsersCell,

  makeAddressCell,
  makeCountCell,
  makeDefaultCell,
  makeHeaderCell,
};
